import { render, staticRenderFns } from "./TheGallery.vue?vue&type=template&id=45b3f8e6&scoped=true&"
import script from "./TheGallery.vue?vue&type=script&lang=js&"
export * from "./TheGallery.vue?vue&type=script&lang=js&"
import style0 from "./TheGallery.vue?vue&type=style&index=0&id=45b3f8e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b3f8e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VCarousel,VCarouselItem,VResponsive})
